// @flow
import nest from 'recompose/nest'

import { WithRouterParamsProviderV3 } from 'app/common/context/WithRouterParams'

import CafeteriaPage from './CafeteriaPage'
import MenuPage from './SectionPages/MenuPage'
import PurchasesPage from './SectionPages/PurchasesPage'
import OrdersPage from './SectionPages/OrdersPage'
import SchedulePage from './SectionPages/SchedulePage'
import FinancesPage from './SectionPages/FinancesPage'
import PaymentOrdersPage from './SectionPages/PaymentOrdersPage'
import SubsidiesPage from './SectionPages/SubsidiesPage'
import OrderRequestsPage from './SectionPages/OrderRequestsPage'
import SettingsPage from './SectionPages/SettingsPage'
import FundPage from './SectionPages/FundPage'
import { CompensationPage } from './SectionPages/CompensationPage'

export const CafeteriaMenuPage = nest(CafeteriaPage, nest(WithRouterParamsProviderV3, MenuPage))

export const CafeteriaPurchasesPage = nest(
  CafeteriaPage,
  nest(WithRouterParamsProviderV3, PurchasesPage),
)

export const CafeteriaOrdersPage = nest(CafeteriaPage, nest(WithRouterParamsProviderV3, OrdersPage))

export const CafeteriaSchedulePage = nest(
  CafeteriaPage,
  nest(WithRouterParamsProviderV3, SchedulePage),
)

export const CafeteriaFinancesPage = nest(
  CafeteriaPage,
  nest(WithRouterParamsProviderV3, FinancesPage),
)

export const CafeteriaPaymentOrdersPage = nest(
  CafeteriaPage,
  nest(WithRouterParamsProviderV3, PaymentOrdersPage),
)

export const CafeteriaSubsidiesPage = nest(
  CafeteriaPage,
  nest(WithRouterParamsProviderV3, SubsidiesPage),
)

export const CafeteriaOrderRequestsPage = nest(
  CafeteriaPage,
  nest(WithRouterParamsProviderV3, OrderRequestsPage),
)

export const CafeteriaSettingsPage = nest(
  CafeteriaPage,
  nest(WithRouterParamsProviderV3, SettingsPage),
)

export const CafeteriaFundPage = nest(CafeteriaPage, nest(WithRouterParamsProviderV3, FundPage))

export const CafeteriaCompensationPage = nest(
  CafeteriaPage,
  nest(WithRouterParamsProviderV3, CompensationPage),
)
